export const CHECKOUT_CLOSE_EVENT = "checkout.close";
export const SWITCH_METHOD_EVENT = "checkout.method.switch";